import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import Loading from "_shared/components/Loading/Loading";
import { formatDate } from "_shared/helpers/formatting";
import { Invoice, invoiceSchema } from "../../models/Invoices";

function Invoices() {
  const [invoicesList, setInvoicesList] = useState<Invoice[]>();

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    const invoicesRes = await API.post("auth", "/cognito/listInvoices", {});
    const fetchedInvoices: Invoice[] = invoicesRes.map((invoiceRes: any) => {
      const parsed = invoiceSchema.safeParse(invoiceRes);
      if (parsed.success) {
        return parsed.data;
      } else {
        // fail silently but log error
        console.error(parsed.error);
        return invoiceRes;
      }
    });
    setInvoicesList(fetchedInvoices);
  };

  return (
    <div
      id="invoice-list"
      className="manage-subscriptions"
      style={{ width: "100%" }}
    >
      <div className="my-subscription-text" style={{ marginTop: 20 }}>
        Invoices
      </div>
      {!invoicesList ? (
        <Loading variant="inner" />
      ) : (
        <div className="add-subscriptions" style={{ width: "100%" }}>
          <div className="table">
            <div
              className="row-header payment-row"
              style={{ gridTemplateColumns: "12% 25% 30% 18% 15%" }}
            >
              <div className="column-header">Date</div>
              <div className="column-header">Order #</div>
              <div className="column-header">Plans</div>
              <div className="column-header">Price</div>
              <div className="column-header">
                {window.matchMedia("(max-width: 480px)").matches
                  ? " "
                  : "Download"}
              </div>
            </div>
            {invoicesList.map((invoice) => {
              return (
                <div
                  key={invoice.orderNumber}
                  className="row payment-row"
                  style={{ gridTemplateColumns: "12% 25% 30% 18% 15%" }}
                >
                  <div
                    style={{ justifyContent: "center" }}
                    className="column-1"
                  >
                    {invoice.date instanceof Date
                      ? formatDate(invoice.date, true)
                      : `${invoice.date}`}
                  </div>
                  <div
                    style={{ justifyContent: "center" }}
                    className="column-1"
                  >
                    {invoice.orderNumber}
                  </div>
                  <div
                    style={{ justifyContent: "center" }}
                    className="column-1"
                  >
                    {invoice.plans === "Cryptocurrencies"
                      ? "Crypto"
                      : invoice.plans}
                  </div>
                  <div
                    style={{ justifyContent: "center" }}
                    className="column-1"
                  >
                    ${invoice.amount}
                  </div>
                  <a
                    href={invoice.link}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textAlign: "center", color: "#75ce41" }}
                  >
                    <i className="fas fa-download" />
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default Invoices;
